import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle2 q-mb-sm" }, "Select target person", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-grey-6 q-mb-md" }, " All faces from other selected persons will be moved to the target. The other persons will be deleted. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Merge People",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_q_btn, {
        flat: "",
        label: "Cancel",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hide()))
      }),
      _createVNode(_component_async_btn, {
        label: "Merge",
        color: "primary",
        task: _ctx.task,
        disabled: !_ctx.canMerge,
        onClick: _ctx.merge
      }, null, 8, ["task", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.persons.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_q_list, {
              bordered: "",
              separator: "",
              class: "rounded-borders"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (person) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: person.id,
                    clickable: "",
                    active: _ctx.targetPersonId === person.id,
                    onClick: ($event: any) => (_ctx.targetPersonId = person.id)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_avatar, {
                            size: "40px",
                            color: "grey-3",
                            "text-color": "grey-6"
                          }, {
                            default: _withCtx(() => [
                              (person.primaryFace && person.primaryFace.imageUrl)
                                ? (_openBlock(), _createBlock(_component_q_img, {
                                    key: 0,
                                    src: person.primaryFace.imageUrl,
                                    fit: "cover"
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 1,
                                    name: "fa fa-user"
                                  }))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(person.label || 'Unnamed Person'), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(person.faceCount || 0) + " faces", 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_radio, {
                            modelValue: _ctx.targetPersonId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetPersonId) = $event)),
                            val: person.id
                          }, null, 8, ["modelValue", "val"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["active", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}